(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/hooks/use-price.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/hooks/use-price.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const PROLONG_SUBSCRIPTION = svs.numbergames.prolong_game.common.constants.PROLONG_SUBSCRIPTION;
const _svs$numbergames = svs.numbergames,
  productMapping = _svs$numbergames.productMapping,
  rules = _svs$numbergames.rules;

const calculateLottoPrice = _ref => {
  let wager = _ref.wager,
    numDraws = _ref.numDraws,
    selectedDays = _ref.selectedDays;
  const lottoBet = wager.wager.bets.find(bet => productMapping.isLotto(bet.productId));
  const hasLotto2 = Boolean(parseInt(lottoBet === null || lottoBet === void 0 ? void 0 : lottoBet.betAmountSalesGroup2, 10));
  const jokerBet = wager.wager.bets.find(bet => productMapping.isJoker(bet.productId));
  const jokerPrice = jokerBet ? parseInt(jokerBet.betAmountSalesGroup1, 10) / jokerBet.numDraws : 0;
  return selectedDays.reduce((totalPrice, productItsId) => {
    let price = 0;
    for (let i = 0; i < numDraws; i++) {
      const rowPrice = rules.getRules(productItsId).rowPrice;
      price += wager.rowCount * rowPrice * (hasLotto2 + 1);
      price += jokerPrice;
    }
    return totalPrice + price;
  }, 0);
};
const usePrice = (drawCount, selectedDays, wager) => {
  const betAmount = wager.betAmount,
    totalDrawCount = wager.totalDrawCount;
  const drawBetAmount = parseInt(betAmount, 10) / totalDrawCount;
  const _useState = useState(betAmount),
    _useState2 = _slicedToArray(_useState, 2),
    price = _useState2[0],
    setPrice = _useState2[1];
  useEffect(() => {
    const numDraws = drawCount === PROLONG_SUBSCRIPTION ? 1 : parseInt(drawCount, 10);
    let newPrice;
    if (productMapping.isLotto(wager.productName)) {
      newPrice = calculateLottoPrice({
        wager,
        numDraws,
        selectedDays
      });
    } else {
      newPrice = drawBetAmount * selectedDays.length * numDraws;
    }
    setPrice(newPrice);
  }, [drawBetAmount, drawCount, selectedDays, wager]);
  return price;
};
setGlobal('svs.numbergames.prolong_game.hooks.usePrice', usePrice);

 })(window);